// module "utils/.js"


function log(data) {
  // console.log(data);
}

export const intercomTrackEvent = (eventName, eventMetadata) => {
  try {
    if (!window.Intercom || typeof window.Intercom !== "function") {
      return;
    }
    window.Intercom("trackEvent", eventName, eventMetadata);
    log("Event sent to Intercom: " + eventName);
    log(eventMetadata);
  } catch (e) {
    console.error("Intercom error", e);
    //Raygun.send(e);
  }
};

export const intercomSendData = data => {
  try {
    if (!window.Intercom || typeof window.Intercom !== "function") {
      return;
    }
    window.Intercom("update", data);
    log("Data sent to Intercom");
    log(data);
  } catch (e) {
    console.error("Intercom error", e);
    //Raygun.send(e);
  }
};
